var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"top-header"}},[_vm._m(0),_c('div',{staticClass:"center-title"},[_vm._v("商储物流绿色城市配送平台")]),_c('div',{staticClass:"right-time"},[_vm._v(_vm._s(_vm.nowTime))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-logo"},[_c('img',{attrs:{"src":require("./img/logo_login.png")}})])
}]

export { render, staticRenderFns }